import { Skeleton } from "@mui/material";
import React from "react";

const SkeletonDemurrageCard = (props) => {
  return (
    <>
      <Skeleton
        variant="rectangular"
        height={250}
        style={{ width: "100%", marginTop: "1rem" }}
      />
      <Skeleton
        variant="rectangular"
        height={250}
        style={{ width: "100%", marginTop: "1rem" }}
      />
    </>
  );
};

export default SkeletonDemurrageCard;
